export { default as StartingLocationCard } from './StartingLocationCard';
export type { StartingLocationCardProps } from './StartingLocationCard';
